// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

/**
 * Debouncer state.
 */
export class DebounceSnapshot implements flatbuffers.IUnpackableObject<DebounceSnapshotT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): DebounceSnapshot {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsDebounceSnapshot(
    bb: flatbuffers.ByteBuffer,
    obj?: DebounceSnapshot,
  ): DebounceSnapshot {
    return (obj || new DebounceSnapshot()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsDebounceSnapshot(
    bb: flatbuffers.ByteBuffer,
    obj?: DebounceSnapshot,
  ): DebounceSnapshot {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new DebounceSnapshot()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  messageKeyHash(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint64(this.bb_pos + offset) : 0n;
  }

  holdDurationMs(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  superseded(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  cancelledByOpposite(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  timerDurationMs(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  static startDebounceSnapshot(builder: flatbuffers.Builder) {
    builder.startObject(5);
  }

  static addMessageKeyHash(builder: flatbuffers.Builder, messageKeyHash: bigint) {
    builder.addFieldInt64(0, messageKeyHash, 0n);
  }

  static addHoldDurationMs(builder: flatbuffers.Builder, holdDurationMs: number) {
    builder.addFieldInt32(1, holdDurationMs, 0);
  }

  static addSuperseded(builder: flatbuffers.Builder, superseded: boolean) {
    builder.addFieldInt8(2, +superseded, +false);
  }

  static addCancelledByOpposite(builder: flatbuffers.Builder, cancelledByOpposite: boolean) {
    builder.addFieldInt8(3, +cancelledByOpposite, +false);
  }

  static addTimerDurationMs(builder: flatbuffers.Builder, timerDurationMs: number) {
    builder.addFieldInt32(4, timerDurationMs, 0);
  }

  static endDebounceSnapshot(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createDebounceSnapshot(
    builder: flatbuffers.Builder,
    messageKeyHash: bigint,
    holdDurationMs: number,
    superseded: boolean,
    cancelledByOpposite: boolean,
    timerDurationMs: number,
  ): flatbuffers.Offset {
    DebounceSnapshot.startDebounceSnapshot(builder);
    DebounceSnapshot.addMessageKeyHash(builder, messageKeyHash);
    DebounceSnapshot.addHoldDurationMs(builder, holdDurationMs);
    DebounceSnapshot.addSuperseded(builder, superseded);
    DebounceSnapshot.addCancelledByOpposite(builder, cancelledByOpposite);
    DebounceSnapshot.addTimerDurationMs(builder, timerDurationMs);
    return DebounceSnapshot.endDebounceSnapshot(builder);
  }

  unpack(): DebounceSnapshotT {
    return new DebounceSnapshotT(
      this.messageKeyHash(),
      this.holdDurationMs(),
      this.superseded(),
      this.cancelledByOpposite(),
      this.timerDurationMs(),
    );
  }

  unpackTo(_o: DebounceSnapshotT): void {
    _o.messageKeyHash = this.messageKeyHash();
    _o.holdDurationMs = this.holdDurationMs();
    _o.superseded = this.superseded();
    _o.cancelledByOpposite = this.cancelledByOpposite();
    _o.timerDurationMs = this.timerDurationMs();
  }

  unpackFields(...fields: string[]): DebounceSnapshotT {
    const t = new DebounceSnapshotT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("message_key_hash")) {
      t.messageKeyHash = this.messageKeyHash();
    }
    if (fieldSet.has("hold_duration_ms")) {
      t.holdDurationMs = this.holdDurationMs();
    }
    if (fieldSet.has("superseded")) {
      t.superseded = this.superseded();
    }
    if (fieldSet.has("cancelled_by_opposite")) {
      t.cancelledByOpposite = this.cancelledByOpposite();
    }
    if (fieldSet.has("timer_duration_ms")) {
      t.timerDurationMs = this.timerDurationMs();
    }
    return t;
  }
}

export class DebounceSnapshotT implements flatbuffers.IGeneratedObject {
  constructor(
    public messageKeyHash: bigint = 0n,
    public holdDurationMs: number = 0,
    public superseded: boolean = false,
    public cancelledByOpposite: boolean = false,
    public timerDurationMs: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return DebounceSnapshot.createDebounceSnapshot(
      builder,
      this.messageKeyHash,
      this.holdDurationMs,
      this.superseded,
      this.cancelledByOpposite,
      this.timerDurationMs,
    );
  }

  clone(): DebounceSnapshotT {
    const obj = new DebounceSnapshotT();
    obj.messageKeyHash = this.messageKeyHash;
    obj.holdDurationMs = this.holdDurationMs;
    obj.superseded = this.superseded;
    obj.cancelledByOpposite = this.cancelledByOpposite;
    obj.timerDurationMs = this.timerDurationMs;
    return obj;
  }

  equals(other: DebounceSnapshotT): boolean {
    if (this.messageKeyHash !== other.messageKeyHash) return false;
    if (this.holdDurationMs !== other.holdDurationMs) return false;
    if (this.superseded !== other.superseded) return false;
    if (this.cancelledByOpposite !== other.cancelledByOpposite) return false;
    if (this.timerDurationMs !== other.timerDurationMs) return false;
    return true;
  }
}

export function verifyDebounceSnapshot(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 8);
    verifier.checkScalarField(tablePos, 6, 4);
    verifier.checkScalarField(tablePos, 8, 1);
    verifier.checkScalarField(tablePos, 10, 1);
    verifier.checkScalarField(tablePos, 12, 4);
  } finally {
    verifier.popDepth();
  }
}
